/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cn from 'classnames';
import { selectSectionAndCategory, setSkinTone } from '../../actions';

const SkinToneFilters = ({
    projectTitle = '',
    setEnableBuilder,
    dispatch,
    activeSection,
    showEditProjectInput = false,
    setShowSkinToneSelector,
    skintone = '',
    currentBuildIndex,
    activeFilters = null,
}) => {
    const skinTonesFilters = [
        {
            value: 'Yellow',
        },
        {
            value: 'Light',
        },
        {
            value: 'Nougat',
        },
        {
            value: 'Medium',
        },
        {
            value: 'Dark',
        },
    ];

    const handleSkinTonePress = (e) => {
        const { filtervalue: filterValue /* filterkey: filterKey */ } = e.target.dataset;

        dispatch(setSkinTone(currentBuildIndex, filterValue));

        if (projectTitle && !showEditProjectInput && setEnableBuilder) {
            setEnableBuilder(true);
        }

        if (setShowSkinToneSelector) {
            setShowSkinToneSelector(false);
        }

        if (activeSection === 'heads' || activeSection === 'legs') {
            dispatch(
                selectSectionAndCategory(
                    {
                        id: activeSection,
                        title: activeSection === 'heads' ? 'Heads' : 'Legs',
                        emptyText: activeSection === 'heads' ? 'Choose a head' : 'Choose a pair of legs',
                        handle: activeFilters
                            ? activeFilters.filterHandle
                            : activeSection === 'heads'
                            ? 'all-heads-new-1'
                            : 'all-legs',
                    },
                    null,
                    filterValue
                )
            );
        }
    };

    return (
        <>
            {skinTonesFilters.map((skinTone) => (
                <button
                    className={cn('skinToneFilterContainer', {
                        active: skintone?.toLowerCase() === skinTone.value.toLowerCase(),
                    })}
                    key={skinTone.value}
                    data-filtervalue={skinTone.value}
                    data-filterkey="colour"
                    onClick={handleSkinTonePress}
                    aria-checked={skintone?.toLowerCase() === skinTone.value.toLowerCase()}
                    aria-label={skinTone.value}
                >
                    <div className={`skinToneFilter ${skinTone.value.toLowerCase()}  `}>
                        <span className="vh">{skinTone.value}</span>
                    </div>
                </button>
            ))}
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        currentBuildIndex: state.currentBuildIndex,
        activeSection: state.navigation.selected,
        activeFilters: state.activeFilter,
        skintone: state.builds[state.currentBuildIndex].skintone,
    };
};

SkinToneFilters.propTypes = {
    projectTitle: PropTypes.string,
    setEnableBuilder: PropTypes.func,
    dispatch: PropTypes.func.isRequired,
    activeSection: PropTypes.string.isRequired,
    showEditProjectInput: PropTypes.bool,
    setShowSkinToneSelector: PropTypes.func,
    skintone: PropTypes.string,
    currentBuildIndex: PropTypes.number.isRequired,
    activeFilters: PropTypes.shape({
        filterHandle: PropTypes.string,
    }),
};

export default connect(mapStateToProps)(SkinToneFilters);
